import service from '@/utils/axios-v2'

/**
 * 获取卡车列表
 * @param {Object} params 
 * eg: {
 *  ifPageAble { Number } 是否分页 0不分页，1分页，默认为0
 *  page { Number } 当前页 默认为1
 *  size { Number } 每页的数量 默认为10
 *  type { Number } truck类型 1为推荐卡车 2为自己的卡车，默认为1
 * }
 */
export function getTruckList() {
  return service({
    url: '/fleet/truck/info/list?ifPageAble=0',
    method: 'get',
    headers: {
      'portal-token': true,
      'no-common-token': true
    },
    isNotPrompt: true
  })
}

export function updateTruck(params) {
  return service({
    url: '/fleet/truck/info/edit',
    method: 'put',
    data: params,
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}

export function addTruck(params) {
  return service({
    url: '/fleet/truck/add',
    method: 'post',
    data: params,
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}